import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37c916f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = { class: "main-row" }
const _hoisted_3 = { class: "congrats-card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score-title" }, "Správné odpovědi:", -1))
const _hoisted_5 = { class: "score-value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two-spacer" }, null, -1))
const _hoisted_10 = { class: "form" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Nenechte si uniknout soutěže a novinky!", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Přihlaste se k odběru našeho newsletteru, nepropásněte žádnou z novinek od Grohe a buďte mezi prvními, kteří se budou moci zapojit do budoucích soutěží. Níže vyplňte celé jméno a emailovou adresu. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-spacer" }, null, -1))

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { resultMessages } from '@/textConfig'

import FinalForm from './FinalForm.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const isActive = ref(false)
const resultTitle = ref('')
const resultMessage = ref('')

const scoreText = computed(() => `${store.getters.score} / ${store.state.questions.length}`)

store.subscribe((mutation) => {
  if (mutation.type === 'finish') {
    isActive.value = true
    const msg = resultMessages.find(
      (m) => m.min <= store.getters.score && store.getters.score <= m.max,
    )
    resultTitle.value = (msg && msg.title) || 'config title error'
    resultMessage.value = (msg && msg.message) || 'config message error'
  }
  if (mutation.type === 'submit') {
    isActive.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(scoreText)), 1),
            _hoisted_6,
            _createElementVNode("div", {
              class: "description-title",
              innerHTML: resultTitle.value
            }, null, 8, _hoisted_7),
            _createElementVNode("div", {
              class: "description-text",
              innerHTML: resultMessage.value
            }, null, 8, _hoisted_8)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _createVNode(FinalForm)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})